'use strict';

import BaseLogger from './base-logger';
import BiLoadStartDataItem from './data-items/bi-load-start-item';
import time from './time/time';
import appData from './app-data/app-data';

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
export default class WidgetLoggerInstance extends BaseLogger {
  constructor(appName, appVersion, reporter, {sessionId, disableAutoLoadFinish}) {
    super(appName, appVersion, reporter, {sessionId, disableAutoLoadFinish});
    appData.init(this.appName);
  }

  /**
   * Manual report for widget load start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14)
   * Call this method at the earliest point possible when your widget starts loading
   */
  appLoadStarted() {

    time.loadStarted(this.appName);

    const dataSource = this.dataSource.clone()
      .addItem(new BiLoadStartDataItem(this.sessionId));

    return this._report(dataSource);
  }

  isDisableAutoLoadFinish() {
    return this._isDisableAutoLoadFinish();
  }
}



// WEBPACK FOOTER //
// ./widget-logger-instance.js